export const PAYPAL_REST_API = `/api/payment/integration/paypal-rest/account`
